import Vue from 'vue'
import App from './App.vue'
import store from './store'
import swiper from './plugins/swiper'

import 'normalize.css/normalize.css'
import './style.scss'

Vue.config.productionTip = false

new Vue({
  store,
  swiper,
  render: h => h(App),
}).$mount('#app')
